import React from 'react'
import { FaCircleCheck } from 'react-icons/fa6'
import { HiOutlineArrowLongRight } from 'react-icons/hi2'

import { ContainerSectionServicesCircularYearsExperience } from './styles'
import useAppConfig from '../../../../hooks/useAppConfig'
import ArrowCurvedSVG from '../../../../assets/svgs/arrow-curved'
import { logFirebaseEvent } from '../../../../services/firebase/analytics'

export default function SectionServicesCircularYearsExperience() {
  const { appConfig } = useAppConfig()

  const handleANalyticsButtonClick = () => {
    logFirebaseEvent('button_click', {
      button_name: 'see_more_new_page',
      screen_name: 'landing_page',
    })
  }

  return (
    <ContainerSectionServicesCircularYearsExperience
      id="section-services-landing-page"
      color={
        appConfig?.appConfig?.styles?.forceSecondaryColor ? 'true' : undefined
      }
    >
      <div className="middle-section">
        <div className="m-s-left">
          <div className="m-s-l-image">&nbsp;</div>
          <div className="m-s-l-box-circle">
            {/* <div className="m-s-l-float-years">
              <div className="date">
                {appConfig?.appConfig?.services?.since ?? '8'}
              </div>
              <div className="date-message">Years of experience</div>
            </div> */}
          </div>
        </div>
        <div className="m-s-right">
          <div className="m-s-r-label">
            {appConfig?.appConfig?.services?.label ?? 'WHY CHOOSE US'}
            <span>
              <ArrowCurvedSVG />
            </span>
          </div>
          <div className="m-s-r-title">
            {appConfig?.appConfig?.services?.title ??
              'Experiencing Traditions Cultural Immersion'}
          </div>
          <div className="m-s-r-box-list">
            {appConfig?.appConfig?.services.serviceList
              .slice(0, 3)
              .map((serviceValue, _index) => {
                return (
                  <div
                    className="m-s-r-service"
                    key={`m-s-r-service-${_index}`}
                  >
                    <div className="m-s-r-service-box-top">
                      <div className="m-s-r-service-box-top-icon">
                        <FaCircleCheck />
                      </div>
                      <div className="m-s-r-service-box-top-title">
                        {serviceValue.title}
                      </div>
                    </div>
                    <div className="m-s-r-service-box-top-description">
                      {serviceValue.description}
                    </div>
                  </div>
                )
              })}
          </div>
          <div
            className="m-s-r-service-see-more"
            onClick={() => {
              handleANalyticsButtonClick()
            }}
            aria-hidden
          >
            {appConfig?.appConfig?.services?.actionNextLabel ??
              'Check specialties'}
            <HiOutlineArrowLongRight />
          </div>
        </div>
      </div>
    </ContainerSectionServicesCircularYearsExperience>
  )
}
